module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTQxNiAzODRhNjQgNjQgMCAwIDAgNjQtNjRWNjRoMzUyYTMyIDMyIDAgMCAxIDMyIDMydjgzMmEzMiAzMiAwIDAgMS0zMiAzMkgxOTJhMzIgMzIgMCAwIDEtMzItMzJWMzg0aDI1NnogbTAtMzE3LjFWMzIwSDE2Mi45YTMyIDMyIDAgMCAxIDYuNS05LjRsMjM3LjItMjM3LjJBMzIgMzIgMCAwIDEgNDE2IDY2Ljl6IiBmaWxsPSIjMCIgcC1pZD0iNDg0NCI+PC9wYXRoPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Document-filled.svg
// module id = Wljd
// module chunks = 75